// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"89465af3","476":"8dabcbff","656":"7cccebc3","706":"72d7bc40","787":"a2787844","826":"b08cf124"}[chunkId] + ".chunk.js";
};